import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="container">
        <div className="header__content">
          {/* Logo */}
          <div className="header__logo">
            <div className="logo">
              <div className="logo__icon">
                <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Mediway Nextgen logo" />
              </div>
              <div className="logo__text">
                <span className="logo__title">Mediway Nextgen</span>
                <span className="logo__subtitle">by Wayug • Hms</span>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav className={`header__nav ${isMobileMenuOpen ? 'header__nav--open' : ''}`}>
            <ul className="nav__list">
              <li><Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="nav__link">Home</Link></li>
              <li><Link to="/features" onClick={() => setIsMobileMenuOpen(false)} className="nav__link">Features</Link></li>
              <li className="nav__item dropdown">
                <span className="nav__link dropdown-toggle">
                  Solutions <span className="arrow">▾</span>
                </span>
                <ul className="dropdown-menu">
                  <li><Link to="/nursing-home-software-india" onClick={() => setIsMobileMenuOpen(false)} className="dropdown-item">Nursing Home Software</Link></li>
                  <li><Link to="/diagnostic-centre-software-india" onClick={() => setIsMobileMenuOpen(false)} className="dropdown-item">Diagnostic Centre LIS</Link></li>
                  <li><Link to="/emr-software-small-hospital" onClick={() => setIsMobileMenuOpen(false)} className="dropdown-item">Small Hospital EMR</Link></li>
                  <li><Link to="/abha-integration-hospital" onClick={() => setIsMobileMenuOpen(false)} className="dropdown-item">ABHA/ABDM Integrated HMS</Link></li>
                </ul>
              </li>
              <li><Link to="/about" onClick={() => setIsMobileMenuOpen(false)} className="nav__link">About</Link></li>
              <li><Link to="/services" onClick={() => setIsMobileMenuOpen(false)} className="nav__link">Services</Link></li>
              <li><Link to="/pricing" onClick={() => setIsMobileMenuOpen(false)} className="nav__link">Pricing</Link></li>
              <li><Link to="/contact" onClick={() => setIsMobileMenuOpen(false)} className="nav__link">Contact</Link></li>
            </ul>
          </nav>

          {/* CTA Button */}
          <div className="header__actions">
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="btn btn-primary header__cta"
            >
              Get Demo
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="header__mobile-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span className={`hamburger ${isMobileMenuOpen ? 'hamburger--active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;